import { executeFormulaSingleRow } from "tailwindui/pages/datagrid/utils"
const indexMapping = (sheetColumns) => {
    const indexMapping1 = []
    const visibleIndexMapping = []
    sheetColumns.forEach((column, index) => {
        indexMapping1.push(column._id)
    })
    sheetColumns.filter(h => !h.hidden).forEach((column, index) => {
        visibleIndexMapping.push(indexMapping1.indexOf(column._id))
    })
    return {
        visibleIndexMapping
    }
}
const cellUpdatesV2 = (state, updates) => {

    if (updates && Array.isArray(updates)) {
        const sheetsObj = state.sheets.reduce((sheetsObj, sheet) => {
            sheetsObj[sheet._id] = sheet
            return sheetsObj
        }, {})
        const activeSheetId = state.activeSheetId
        const updateCells = []
        updates.forEach(update => {
            const { tableId, rowId, cellId, value, rowIds } = update
            if (rowIds && rowIds.length > 0) {
                rowIds.forEach(rowId => {
                    if (sheetsObj && sheetsObj[tableId] && sheetsObj[tableId].data.rows && sheetsObj[tableId].data.rows[rowId]) {
                        const index = sheetsObj[tableId].data.headers.indexOf(cellId)
                        if (index !== -1) {
                            sheetsObj[tableId].data.rows[rowId][index] = value
                            const row = Object.keys(sheetsObj[tableId].data.rows).findIndex(r => r === rowId)
                            if (activeSheetId === tableId) {
                                updateCells.push({ cell: [index, row] })
                            }
                        }
                    }
                })
            }
            if (sheetsObj && sheetsObj[tableId] && sheetsObj[tableId].data.rows && sheetsObj[tableId].data.rows[rowId]) {
                const index = sheetsObj[tableId].data.headers.indexOf(cellId)
                if (index !== -1) {
                    sheetsObj[tableId].data.rows[rowId][index] = value
                    const row = Object.keys(sheetsObj[tableId].data.rows).findIndex(r => r === rowId)
                    if (activeSheetId === tableId) {
                        updateCells.push({ cell: [index, row] })
                    }
                }
            }
        })
        if (updateCells && updateCells.length > 0 && window.tableRef?.current) {

            setTimeout(() => {
                window.tableRef.current.updateCells(updateCells)
            }, 1000)
        }
        return [...Object.values(sheetsObj)]
    } else if (updates && updates && updates.tableId && updates.rowId && updates.cellId) {
        console.log('sing')
        const { tableId, rowId, cellId, value } = updates
        const sheetsObj = state.sheets.reduce((sheetsObj, sheet) => {
            sheetsObj[sheet._id] = sheet
            return sheetsObj
        }, {})
        if (sheetsObj && sheetsObj[tableId] && sheetsObj[tableId].data.rows && sheetsObj[tableId].data.rows[rowId]) {
            const index = sheetsObj[tableId].data.headers.indexOf(cellId)
            if (index !== -1) {
                sheetsObj[tableId].data.rows[rowId][index] = value
            }
        }
        return [...Object.values(sheetsObj)]
    }
    return state.sheets
}
const statsUpdatesV2 = (state, updates) => {
    if (updates && Array.isArray(updates)) {
        const tableStats = state.tableStats ?? {}
        const validTableIds = state.sheets.map(sheet => sheet._id)
        updates.forEach(update => {
            const { tableId } = update
            if (validTableIds.includes(tableId)) {
                if (tableStats && tableStats[tableId]) {
                    tableStats[tableId] = update
                } else {
                    tableStats[tableId] = update
                }
            }
        })
        return {...tableStats}
    }
    return {...state.tableStats}
}
const initialState = {
    sheets: [],
    activeSheetId: null,
    loading: false,
    error: null,
    table: null,
    tableStats: null,
    systemStats: null,
    connected: undefined,
    visibleData: null
}
const sheetsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case 'TABLE_VISIBLE_DATA_V2':
            return {
                ...state,
                visibleData: payload
            }
        case 'SHEETS_LOADING':
            return {
                ...state,
                loading: payload
            }
        case 'ADD_NEW_SHEET_ROWS_COUNT':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        return {
                            ...sheet,
                            totalRows: sheet.totalRows + payload.rows.length
                        }
                    }
                    return sheet
                }),
                currentSheetData: state.activeSheetId === payload.sheetId ? {
                    ...state.currentSheetData,
                    totalRows: state.currentSheetData.totalRows + payload.rows.length
                } : state.currentSheetData
            }

        case 'SET_ENRICHMENT_STATUS_SHEET':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.tableId) {
                        return {
                            ...sheet,
                            isProcessing: payload.isProcessing,
                            importStatus: payload.isProcessing ? 'Processing' : 'Completed'
                        }
                    }
                    return sheet
                }),
                currentSheetData: state.activeSheetId === payload.tableId ? {
                    ...state.currentSheetData,
                    isProcessing: payload.isProcessing,
                    importStatus: payload.isProcessing ? 'Processing' : 'Completed'
                } : state.currentSheetData
            }
        case 'TABLE_STATS':
            return {
                ...state,
                tableStats: payload
            }
        case 'SOCKET_CONNECTED':
            return {
                ...state,
                connected: payload
            }
        case 'SYSTEM_STATS':
            return {
                ...state,
                systemStats: payload
            }
        case 'SET_TOTAL_ROWS':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.tableId) {
                        return {
                            ...sheet,
                            totalRows: payload.totalRows,
                            importStatus: 'Completed'
                        }
                    }
                    return sheet
                }),
                currentSheetData: state.activeSheetId === payload.tableId ? {
                    ...state.currentSheetData,
                    totalRows: payload.totalRows,
                    importStatus: 'Completed'
                } : state.currentSheetData
            }
        case 'SET_TABLE_DG_CLEANUP':
            return {
                ...initialState
            }
        case 'SET_SHEETS_LOADING':
            return {
                ...state,
                sheetsLoading: payload,
            }
        case 'SET_SHEETS_LOADED':
            return {
                ...state,
                sheetsLoaded: payload,
            }
        case 'SET_TABLE':
            return {
                ...state,
                table: payload,
            }
        case 'SET_TABLE_LOADING':
            return {
                ...state,
                tableLoading: payload,
            }
        case 'SET_SHEETS':
            const baseTable = payload.find(sheet => sheet.isBaseTable)
            return {
                ...state,
                sheets: payload.map(sheet => ({ ...sheet, ...indexMapping(sheet.columns ?? []) })),
                table: baseTable,
                activeSheetId: baseTable?.workingSheetId ?? baseTable?._id
            }

        case 'SET_CURRENT_SHEET':
            return {
                ...state,
                activeSheetId: payload._id,

            }

        case 'SET_ACTIVE_SHEET':
            return {
                ...state,
                activeSheetId: payload
            }
        case 'SET_CURRENT_SHEET_DATA':
            return {
                ...state,
                currentSheetData: {
                    ...state.currentSheetData ?? {},
                    ...payload
                }
            }

        case 'DELETE_ROWS_DG':
            const sheetData = {
                ...state.currentSheetData,
                rows: state.currentSheetData.rows.filter(row => !payload.includes(row._id)),
                totalRows: state.currentSheetData.totalRows - payload.length
            }
            return {
                ...state,
                currentSheetData: sheetData,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === state.activeSheetId) {
                        return {
                            ...sheet,
                            rows: sheet.rows.filter(row => !payload.includes(row._id)),
                            totalRows: sheetData.totalRows
                        }
                    }
                    return sheet
                })
            }
        case 'NEW_ROW':
            if (payload.tableId) {
                const targetSheet = state.sheets.find(s => s._id === payload.tableId)
                if (targetSheet) {
                    return {
                        ...state,
                        sheets: state.sheets.map(sheet => {
                            if (sheet._id === targetSheet._id) {
                                return {
                                    ...sheet,
                                    rows: [...sheet.rows, payload],
                                    totalRows: sheet.totalRows + 1
                                }
                            }
                            return sheet
                        }),
                        currentSheetData: state.activeSheetId === targetSheet._id ? {
                            ...state.currentSheetData,
                            rows: [...state.currentSheetData.rows, payload],
                            totalRows: state.currentSheetData.totalRows + 1
                        } : state.currentSheetData
                    }
                } else {
                    return state
                }
            } else {
                return state
            }

        case 'UPDATE_ROW':
            if (payload.tableId) {
                const targetSheet = state.sheets.find(s => s._id === payload.tableId)
                if (targetSheet) {
                    return {
                        ...state,
                        sheets: state.sheets.map(sheet => {
                            if (sheet._id === targetSheet._id) {
                                return {
                                    ...sheet,
                                    rows: sheet.rows.map(row => {
                                        if (row._id === payload._id) {
                                            return payload
                                        }
                                        return row
                                    })
                                }
                            }
                            return sheet
                        }),
                        currentSheetData: state.activeSheetId === targetSheet._id ? {
                            ...state.currentSheetData,
                            rows: state.currentSheetData.rows.map(row => {
                                if (row._id === payload._id) {
                                    return payload
                                }
                                return row
                            })
                        } : state.currentSheetData
                    }
                } else {
                    return state
                }
            } else {
                return state
            }
        case 'DELETE_ROWS_SHEET':
            const sheetData2 = {
                ...state.currentSheetData,
                rows: state.activeSheetId === payload.tableId ? state.currentSheetData.rows.filter(row => row._id !== payload.rowId) : state.currentSheetData.rows,
                totalRows: state.activeSheetId === payload.tableId ? state.currentSheetData.totalRows - 1 : state.currentSheetData.totalRows
            }
            return {
                ...state,
                currentSheetData: sheetData2,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.tableId) {
                        return sheetData2
                    } else {
                        return sheet
                    }

                })
            }

        case 'CELL_UPDATES_V2':
            return {
                ...state,
                sheets: cellUpdatesV2(state, payload)
            }
        case 'RUN_ON_ROWS_IDS':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        const colIndex = sheet.data.headers.indexOf(payload.cellId)
                        if(colIndex === -1) {
                            return sheet
                        }
                        const actualIndex = sheet.visibleIndexMapping[colIndex]
                        const rows = sheet.data.rows ?? {}
                        payload.rowsIds.forEach(rowId => {
                            if (rows[rowId]) {
                                rows[rowId][actualIndex] = 'Adding to queue...'
                            }
                        })
                        return {
                            ...sheet,
                            data: {
                                ...sheet.data,
                                rows: {
                                    ...rows,
                                    
                                }
                            }
                        }
                    }
                    return sheet
                })
            }
        case 'CELL_RUN_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        const rowId = payload.rowIds[0]
                        const row = sheet.data.rows[rowId]
                        if (!row) {
                            return sheet
                        }
                        const actualIndex = sheet.visibleIndexMapping[payload.data.colIndex]
                        row[actualIndex] = payload.value
                        return {
                            ...sheet,
                            data: {
                                ...sheet.data,
                                rows: {
                                    ...sheet.data.rows,
                                    [rowId]: row
                                }
                            }
                        }
                    }
                    return sheet
                })
            }
        case 'STATS_UPDATES_V2':
            return {
                ...state,
                tableStats: statsUpdatesV2(state, payload)
            }
        case 'SET_FILTER_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        console.log('payload.filter', payload.filter)
                        return {
                            ...sheet,
                            filter: payload.filter

                        }
                    }
                    return sheet
                })
            }
        case 'ADD_ROW_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.tableId) {
                        const headers = sheet.data.headers ?? []
                        const row = []
                        headers.forEach((header, index) => {
                            row.push(payload[header] ?? '',)
                        })
                        const sheetData = {
                            ...sheet,
                            data: {
                                ...sheet.data,
                                rows: { ...sheet.data.rows, [payload._id]: row ?? [] }

                            },
                            totalRows: sheet.totalRows + 1,
                            filteredRowsCount: sheet.filteredRowsCount + 1
                        }
                        return sheetData
                    }
                    return sheet
                })
            }
        case 'IMPORT_CSV_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        const headers = sheet.data.headers ?? []
                        const rowsObj = {}
                        payload.rows.forEach(row => {
                            const rowData = []
                            headers.forEach((header, index) => {
                                rowData.push(row[header] ?? '',)
                            })
                            rowsObj[row._id] = rowData
                        })
                        const sheetData = {
                            ...sheet,
                            data: {
                                ...sheet.data,
                                rows: { ...sheet.data.rows, ...rowsObj }

                            },
                            totalRows: sheet.totalRows + payload.rows.length,
                            filteredRowsCount: sheet.filteredRowsCount + payload.rows.length
                        }
                        return sheetData
                    }
                    return sheet
                })
            }
        case 'ADD_ROWS_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        const rows = sheet.data.rows ?? {}
                        let count = 0
                        Object.keys(payload.data.rows).forEach((id) => {
                            if (!rows.hasOwnProperty(id)) {
                                rows[id] = payload.data.rows[id] ?? []
                                count = count + 1
                            }
                        })
                        return {
                            ...sheet,
                            filteredRowsCount: sheet.filteredRowsCount + count,
                            totalRows: sheet.totalRows + count,
                            data: {
                                ...sheet.data,
                                rows: rows
                            }
                        }
                    }
                    return sheet
                })
            }
        case 'APPEND_PAGINATED_ROWS_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        const rows = sheet.data.rows ?? {}
                        Object.keys(payload.data.rows).forEach((id) => {
                            if (!rows.hasOwnProperty(id)) {
                                rows[id] = payload.data.rows[id] ?? []
                            }
                        })
                        return {
                            ...sheet,
                            data: {
                                ...sheet.data,
                                rows: rows
                            }
                        }
                    }
                    return sheet
                })
            }
        case 'DELETE_ROWS_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        const rows = sheet.data.rows ?? {}
                        payload.ids.forEach((id) => {
                            if (rows.hasOwnProperty(id)) {
                                delete rows[id]
                            }
                        })
                        return {
                            ...sheet,
                            filteredRowsCount: sheet.filteredRowsCount - payload.ids.length,
                            totalRows: sheet.totalRows - payload.ids.length,
                            data: {
                                ...sheet.data,
                                rows: { ...rows }

                            }
                        }
                    }
                    return sheet
                })
            }
        case 'UPDATE_ROWS_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        const rows = sheet.data.rows ?? {}
                        const updatedRows = payload.rows ?? {}
                        Object.keys(updatedRows).forEach((id) => {
                            if (rows.hasOwnProperty(id)) {
                                rows[id] = updatedRows[id] ?? []
                            }
                        })
                        return {
                            ...sheet,
                            data: {
                                ...sheet.data,
                                rows: { ...rows }

                            }
                        }
                    }
                    return sheet
                })
            }
        case 'UPDATE_CELL_DATA_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        const rowsData = sheet.data.rows ?? {}
                        rowsData[payload.rowId][payload.cell] = payload.value
                        return {
                            ...sheet,
                            data: {
                                ...sheet.data,
                                rows: { ...rowsData }

                            }
                        }
                    }
                    return sheet
                })
            }
        case 'SET_COLUMNS_V2':
            const sheets = state.sheets.map(sheet => {
                if (sheet._id === payload.sheetId) {
                    const sheetColumns = payload.columns
                    const isDeleted = payload.deletedColumnId !== undefined
                    const isDuplicated = payload.duplicatedColumnId !== undefined
                    const labels = payload.columns.map(col => col.label)
                    const headers = payload.columns.map(col => col._id)
                    const deletedIndex = isDeleted ? sheet.data.headers.indexOf(payload.deletedColumnId) : null
                    const addedIndex = !isDeleted ? headers.indexOf(payload.newColumnId) : null
                    const duplicatedIndex = isDuplicated ? headers.indexOf(payload.duplicatedColumnId) : null
                    let rowObj = {}
                    Object.entries(sheet.data.rows).forEach(([rowId, row]) => {
                        if (isDeleted) {
                            row.splice(deletedIndex, 1)
                        } else if (isDuplicated) {
                            row.splice(addedIndex, 0, row[duplicatedIndex])
                        } else {
                            row.splice(addedIndex, 0, '')
                        }
                        rowObj[rowId] = row
                    });
                    return {
                        ...sheet,
                        columns: sheetColumns,
                        data: {
                            ...sheet.data,
                            labels,
                            headers,
                            rows: rowObj
                        },
                        ...indexMapping(sheetColumns)
                    }
                }
                return sheet
            })
            return {
                ...state,
                sheets: [...sheets]
            }

        case 'UPDATE_COLUMN_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.tableId) {
                        const sheetColumns = sheet.columns.map(col => {
                            if (col._id === payload._id) {
                                return payload
                            }
                            return col
                        })
                        const labels = sheetColumns.map(col => col.label)
                        const headers = sheetColumns.map(col => col._id)
                        return {
                            ...sheet,
                            columns: sheetColumns,
                            data: {
                                ...sheet.data,
                                labels,
                                headers,
                            },
                            ...indexMapping(sheetColumns)
                        }
                    }
                    return sheet
                })
            }
        case 'EXECUTE_FORMULA_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        const rows = sheet.data.rows ?? {}
                        const columns = sheet.columns ?? []
                        if (payload.formula && payload.cellId) {
                            const formulaRows = {}
                            const colIndex = columns.findIndex(col => col._id === payload.cellId)
                            Object.keys(rows).forEach((rowId) => {
                                const row = rows[rowId]
                                const { output } = executeFormulaSingleRow(row, payload.formula, columns)
                                row[colIndex] = output
                                formulaRows[rowId] = row
                            })
                            return {
                                ...sheet,
                                data: {
                                    ...sheet.data,
                                    rows: { ...formulaRows }
                                }
                            }
                        } else {
                            return sheet
                        }
                    }
                    return sheet
                })
            }
        case 'PIN_COLUMN_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        return {
                            ...sheet,
                            pin: payload.pin
                        }
                    }
                    return sheet
                })
            }
        case 'REORDER_COLUMNS_V2':
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload.sheetId) {
                        const sheetColumns = payload.columns
                        const labels = sheetColumns.map(col => col.label)
                        const headers = sheetColumns.map(col => col._id)
                        const oldOrder = sheet.data.headers ?? []
                        let rowObj = {}
                        Object.entries(sheet.data.rows).forEach(([rowId, row]) => {
                            const newRow = []
                            headers.forEach((header, index) => {
                                newRow[index] = row[oldOrder.indexOf(header)]
                            })
                            rowObj[rowId] = newRow
                        });
                        return {
                            ...sheet,
                            columns: sheetColumns,
                            data: {
                                ...sheet.data,
                                labels,
                                headers,
                                rows: rowObj
                            },
                            ...indexMapping(sheetColumns)
                        }
                    }
                    return sheet
                })
            }

        case 'ADD_SHEET_V2':
            return {
                ...state,
                sheets: [...state.sheets, payload].map(sheet => ({ ...sheet, ...indexMapping(sheet.columns ?? []) })),
                activeSheetId: payload._id
            }

        case 'SET_FILTERED_DATA_V2':
            return {
                ...state,
                sheets: state.sheets.map(sh => {
                    if (sh._id === payload.sheetId) {
                        return {
                            ...sh,
                            ...payload
                        }
                    }
                    return sh
                })
            }

        case 'UPDATE_TABLE_V2':
            return {
                ...state,
                table: {
                    ...state.table,
                    ...payload
                }
            }

        case 'RENAME_TABLE_V2':
            if (payload.isTable) {
                return {
                    ...state,
                    table: {
                        ...state.table,
                        name: payload.name,
                        description: payload.description,
                        autoEnrich: payload.autoEnrich
                    }
                }
            }
            return {
                ...state,
                sheets: state.sheets.map(sheet => {
                    if (sheet._id === payload._id) {
                        return {
                            ...sheet,
                            sheetName: payload.sheetName,
                            name: payload.name ?? sheet.name
                        }
                    }
                    return sheet
                })

            }

        case 'SWITCH_SHEET_V2':
            return {
                ...state,
                activeSheetId: state.sheets.find(sheet => sheet._id === payload) ? payload : state.activeSheetId
            }


        case 'UPDATE_SHEET':
            return {
                ...state,
                sheets: state.sheets.map(sheet =>
                    sheet._id === payload._id ? { ...sheet, ...payload } : sheet
                ),
                currentSheetData: state.activeSheetId === payload._id ? payload : state.currentSheetData
            }

        case 'UPDATE_SHEET_ROWS':
            return {
                ...state,
                sheets: state.sheets.map(sheet =>
                    sheet._id === payload.sheetId ? { ...sheet, rows: payload.rows } : sheet
                ),
                currentSheetData: state.activeSheetId === payload.sheetId ? {
                    ...state.currentSheetData,
                    rows: payload.rows
                } : state.currentSheetData
            }


        case 'APPEND_SHEET_ROWS':
            return {
                ...state,
                sheets: state.sheets.map(sheet =>
                    sheet._id === payload.sheetId ? { ...sheet, rows: [...sheet.rows, ...payload.rows] } : sheet
                ),
                currentSheetData: state.activeSheetId === payload.sheetId ? {
                    ...state.currentSheetData,
                    rows: [...state.currentSheetData.rows, ...payload.rows]
                } : state.currentSheetData
            }


        case 'DELETE_SHEET':
            return {
                ...state,
                sheets: state.sheets.filter(sheet => sheet._id !== payload)
            }

        case 'SET_LOADING':
            return {
                ...state,
                loading: payload
            }

        case 'SET_ERROR':
            return {
                ...state,
                error: payload
            }

        case 'CLEAR_ERROR':
            return {
                ...state,
                error: null
            }

        // case 'UPDATE_GRID_DATA':
        //     return {
        //         ...state,
        //         ...handleSheetGridData(state, payload)
        //     }

        // case 'UPDATE_CELL_DATA_FROM_DB':
        //     return {
        //         ...state,
        //         ...handleSheetGridDataCellSheet(state, payload)
        //     }
        // case 'TABLE_UPDATES_V2':
        //     return {
        //         ...state,
        //         ...handleSheetGridData(state, payload?.cell_updates ?? [])
        //     }
        default:
            return state
    }
}

export default sheetsReducer
